import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  allAirlines: null,
  airline: null,
  updateAirline: null,
  allAgreements: null,
  agreementTypes: null,
  airlinesByTier: null,
}

const getters = {
  allAirlines() {
    const url = '/airline'
    return axios.get(url)
  },
  airline(airlineId) {
    const url = `/airline/${airlineId}`
    return axios.get(url)
  },
  allAgreements() {
    const url = '/AirlineAgreement'
    return axios.get(url)
  },
  agreementTypes() {
    const url = '/AirlineAgreement/AirlineAgreementTypes'
    return axios.get(url)
  },
  airlinesByTier(agreementTypeIds) {
    const agreementTypeParams = new URLSearchParams()
    agreementTypeIds.forEach(value => {
      agreementTypeParams.append('agreementTypeIds', value.agreementTypeId)
    })
    const url = '/airline/'
    return axios.get(url, {
      params: agreementTypeParams,
    })
  },
}

const saves = {
  updateAirline(airline) {
    const url = `/airline/${airline.id}`
    return axios.put(url, airline)
  },
  newAirline(airline) {
    const url = '/airline'
    return axios.post(url, airline)
  },
  newAgreement(agreement) {
    const url = '/AirlineAgreement'
    return axios.post(url, agreement)
  },
}

export default class AirlineManagementService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
